import styled from 'styled-components'

export const FormContainer = styled.form`
  margin-bottom: 5px;
  max-width: 300px;
  display: flex;
  height: 40px;
`

export const InputNick = styled.input`
  width: 100%;
  padding: 0 10px;
  border-radius: 3px 0 0 3px;
  font-size: 1rem;
  font-weight: bold;
  outline: none;
  border: none;
`

export const Button = styled.button`
  outline: none;
  border: none;
  background: black;
  color: white;
  border-radius: 0 3px 3px 0;
  cursor: pointer;
`
